import StartRating from "stars-rating";

import React, { Component } from "react";

import {
  Modal,
  FormLayout,
  div,
  Spinner,
  TextField,
  Text,
} from "@shopify/polaris";

import { reqInsertContactUs } from "../../api";

import ToastFunc from "../ToastFunc";

import "./index.css";
import { store } from '../../redux/store'

import Language from '../../i18n/Language';
const t = Language

class NewReviewModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingPage: true,
      modalActive: false,
      sheetActive: false,

      title: "",
      description: "",

      //弹窗
      showToast: false, //弹窗显示
      showToastText: "", //弹窗文字
      showToastIserror: false, //弹窗是否错误

      //保存星级
      StarRating: 0,

      Buttonloading: false, // 提交btn loading
    };
  }

  componentDidMount() {
    window.ratingOpera = this;
  }

  handleCloseSheetInsert = () => {
    if (this.props.modalName === "") {
      this.toggleToast(t("Name should not be empty"), true);
      return "";
    } else if (this.state.description === "") {
      this.toggleToast(t("Description should not be empty"), true);
      return "";
    }
    //调用修改数据
    this.updateEamilList();
  };

  //点击链接弹窗
  handleOpenModal = () => {
    this.setState({ modalActive: this.props.open }, () => {
    });
  };

  //关闭链接弹窗
  handleCloseModal = () => {
    this.setState({ modalActive: false });
  };

  //点击星级弹窗
  handleOpenSheet = () => {
    this.setState({ sheetActive: true }, () => {
    });
  };

  //关闭星级弹窗
  handleCloseSheet = () => {
    this.setState({ sheetActive: false });
  };

  ratingChanged = (newRating, e, status = true) => {
    if(newRating === 0) {
      return false;
    } else if (newRating <= 3 && newRating > 0) {
      this.setState({
        StarRating: newRating
      })
      this.handleOpenSheet();
    } else {

      var iWidth = 1400;
      var iHeight = 800;
      var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
      var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
      window.open("https://apps.shopify.com/seo-master?source=evaluate#modal-show=ReviewListingModal", "", 'height=' + iHeight + ',,innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no');

      this.handleCloseSheet();
    }
    this.back(status);
  };

  back = (status) => {// 子组件的点击事件
    this.props.changeData(!status) // 这个changeData()就是激活父组件的方法，可以传值
  }

  //返回状态 如果提交评价 传给父组件一个状态 重新请求接口
  reRequestBack = () => {
    this.props.reRequest(true)
  }

  handleChange = field => {
    return value => this.setState({ [field]: value });
  };

  updateEamilList =  () => {
    this.setState({
      Buttonloading: true,
    }, async () => {
      const params = {
        name: !Boolean(this.props.modalName) ? store.getState().public.shopOwner : this.props.modalName,
        email: this.props.modalEmail ? this.props.modalEmail : this.props.modalDefaultEmail,
        title: "评价:" + this.state.StarRating + "星",
        description: this.state.description
      };
      const responseData = await reqInsertContactUs(params);
      if (responseData.code === "200") {
        this.toggleToast(responseData.msg, false);
        this.reRequestBack();
      } else {
        this.toggleToast(responseData.msg, true);
      }
      this.setState({
        Buttonloading: false,
        sheetActive: false
      });
    });
    
  };

  //提示弹窗
    toggleToast = (showToastText, showToastIserror) => {
        this.setState({
            showToast: false
        }, () => {
            this.setState(({ showToast }) => ({
                showToast: !showToast,
                showToastText: showToastText,
                showToastIserror: showToastIserror
            }));
        });
    };

  componentWillUnmount = async() =>{
    this.setState = () => false
  }

  render() {
    const {
      state: { loadingPage, sheetActive, StarRating, description, Buttonloading },
      props: { content, open, modalName, modalEmail, contentTwo },
      handleCloseSheetInsert,
      handleCloseSheet,
      ratingChanged,
      back,
      handleChange,
    } = this;

    const toastMarkup = this.state.showToast ? (
      <ToastFunc
        content={this.state.showToastText}
        onDismiss={this.state.showToast}
        error={this.state.showToastIserror}
      />
    ) : null;

    const pageContent =
      <Modal
        size="small"
        open={open}
        onClose={back}
        title= {t("SEOAnt Product Review")}
      >
        <Modal.Section>
          {content || contentTwo ? 
            <div style={{ height: "100%", borderBottom: '0.1rem solid #eee', textAlign: 'center' }}>
              <div className="congratulationText">
              <Text variant="headingXl" as="h4">{t("Congratulation")}</Text>
                {content ? <p style={{ marginTop: '1.6rem' }}>{content}</p> : null}
                {contentTwo ? <p style={{ marginTop: '1.6rem' }}>{contentTwo}</p> : null}
              </div>
            </div>
           : ''}
            <div style={{ height: "100%", borderTop: '1px solid #eee' }}>
              <div className="MyStarText">
                  <div>
                    <img src="/newlogo.png?v=12305" alt="SEO Ant" style={{ width: '2rem' }} />
                    <Text variant="headingMd" as="h2">{t("SEOAnt")}</Text>
                  </div>
                  <p>
                    {t("Would you mind us sharing what you think about this APP?")}
                  </p>
              </div>
              <div className="MyStar">
                <StartRating
                  color1='#3CB371'
                  color2='#FFEA8A'
                  char='✩'
                  half={false}
                  count={5}
                  onChange={ratingChanged}
                  size={50}
                />
              </div>
            </div>
        </Modal.Section>
      </Modal>;

    const loadingMarkup = this.state.loading ? (
      <div className="DetailReport_Empty_New_div_margin_800">
        <Spinner size="large" color="teal" />
      </div>
    ) : (
      ""
    );

    //输出星级
    var StarRatingArray = [];
    for (var i = 0; i < StarRating; i++) {
      StarRatingArray.push(<span key={i} className="StarRating" data-index="0" data-forhalf="✩">✩</span>)
    }
    var StarRatingSpan = StarRatingArray.map(function (item) {
      return item
    })

    const pageData = <div>
      <div className="Polaris-Labelled__LabelWrapper"><div className="Polaris-Label"><label className="Polaris-Label__Text">{t("Star rating:")}&nbsp;{StarRatingSpan}</label></div></div>

      <TextField
        label="Name"
        onChange={handleChange("name")}
        value={!Boolean(modalName) ? store.getState().public.shopOwner : modalName}
      />
      <div className="halfspace"></div>
      <TextField
        label="Email"
        onChange={handleChange('email')}
        value={modalEmail}
      />
      <div className="halfspace"></div>
      <TextField
        label="Message"
        onChange={handleChange("description")}
        value={description}
        multiline
      />
    </div>

    const feedbackModal = loadingPage && (
      <Modal
        open={sheetActive}
        onClose={handleCloseSheet}
        title={t("Your feedback is important to us")}
        primaryAction={{
          content: 'Submit',
          onAction: handleCloseSheetInsert,
          loading: Buttonloading
        }}
      >
        <Modal.Section>
          <div style={{ height: "100%" }}>
            <FormLayout>
              {loadingMarkup}
              {pageData}
            </FormLayout>
          </div>
        </Modal.Section>
      </Modal>
    );

    return (
      <div className="footerRating">
        <div className="footerRating_child">
          {pageContent}
          {toastMarkup}
          {feedbackModal}
        </div>
      </div>
    );
  }
}

export default NewReviewModal;